import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "bulk-search-input" };
const _hoisted_2 = { class: "bulk-search-input__file-input-icon" };
const _hoisted_3 = ["placeholder"];
const _hoisted_4 = { class: "bulk-search-input__buttons" };
const _hoisted_5 = ["disabled"];
import { ref, watch } from 'vue';
import productRepository from "@astina/paloma-shop-common-ui/src/services/ProductRepository";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogProductsBulkSearchInput',
    emits: ['search-start', 'search-results'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const inputText = ref('');
        const inputFile = ref(null);
        const inputFileEl = ref(null);
        const loading = ref(false);
        const isDraggingOver = ref(false);
        watch(inputText, () => {
            if (!inputText.value) {
                return;
            }
            emit('search-start');
            loading.value = true;
            inputFile.value = null;
            productRepository.searchProductsBulk(inputText.value)
                .then(onSearchResults)
                .catch(error => alerts.error(trans('catalog.bulk_search.input_text_error', { error })))
                .finally(() => loading.value = false);
        });
        watch(inputFile, () => {
            if (!inputFile.value) {
                return;
            }
            emit('search-start');
            loading.value = true;
            inputText.value = '';
            productRepository.searchProductsBulk(undefined, inputFile.value)
                .then(onSearchResults)
                .catch(error => alerts.error(trans('catalog.bulk_search.input_file_error', { error })))
                .finally(() => loading.value = false);
        });
        function onSearchResults(products) {
            emit('search-results', products);
        }
        function onFileInput(event) {
            inputFile.value = event.target.files?.[0] ?? null;
        }
        function onDrop(event) {
            const file = event.dataTransfer?.files?.[0];
            isDraggingOver.value = false;
            if (!file) {
                return;
            }
            if (file.type && !file.type.startsWith('text/')
                && !file.name.toLowerCase().endsWith('.xlsx')) {
                alerts.error(trans('catalog.bulk_search.error_file_type'));
                return;
            }
            inputText.value = '';
            inputFile.value = file;
        }
        function onDragOver(event) {
            event.preventDefault();
            isDraggingOver.value = true;
        }
        function onDragLeave(event) {
            // Only reset when leaving the form, not when moving between children
            const target = event.currentTarget;
            if (target && !target.contains(event.relatedTarget)) {
                isDraggingOver.value = false;
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("form", {
                    onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"])),
                    onDragover: _withModifiers(onDragOver, ["prevent"]),
                    onDragleave: _withModifiers(onDragLeave, ["prevent"]),
                    onDrop: _withModifiers(onDrop, ["prevent"]),
                    class: _normalizeClass(["bulk-search-input__form", { 'bulk-search-input__form--drag-over': isDraggingOver.value }])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(Icon, {
                            name: "file-upload",
                            "icon-style": "duotone"
                        })
                    ]),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((inputText).value = $event)),
                        class: "bulk-search-input__textarea",
                        rows: "5",
                        placeholder: _ctx.$t('catalog.bulk_search.placeholder')
                    }, null, 8, _hoisted_3), [
                        [
                            _vModelText,
                            inputText.value,
                            void 0,
                            {
                                lazy: true,
                                trim: true
                            }
                        ]
                    ]),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _createElementVNode("input", {
                        type: "file",
                        onChange: onFileInput,
                        accept: ".xlsx,.csv",
                        ref_key: "inputFileEl",
                        ref: inputFileEl,
                        style: { "display": "none" }
                    }, null, 544),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "button button--link",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (inputFileEl.value && inputFileEl.value.click()), ["prevent"]))
                        }, [
                            _createVNode(Icon, { name: "file-spreadsheet" }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('catalog.bulk_search.select_file')), 1)
                        ]),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("button", {
                            type: "submit",
                            class: "button",
                            disabled: loading.value
                        }, [
                            _createVNode(Spinner, { loading: loading.value }, null, 8, ["loading"]),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            (!loading.value)
                                ? (_openBlock(), _createBlock(Icon, {
                                    key: 0,
                                    name: "search"
                                }))
                                : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('catalog.bulk_search.button')), 1)
                        ], 8, _hoisted_5)
                    ])
                ], 34)
            ]));
        };
    }
});
